import Service, { service } from '@ember/service';
import nameSort from 'scaleflow/utils/nameSort';

export default class TeamsService extends Service {
  @service store;
  @service notifications;
  @service intl;

  async getTeams() {
    const teams = this.store.peekAll('team');
    if (teams.length === 0) return await this.loadTeams();
    return this.convertToValueLabel(teams);
  }

  getTeamsSync() {
    return this.store
      .peekAll('team')
      .slice()
      .sort((a, b) => nameSort(a.name, b.name));
  }

  get teamOptions() {
    return this.getTeamsSync()
      .filter((team) => team.active)
      .map((item) => ({
        label: item.name,
        value: item.id,
      }));
  }

  convertToValueLabel(array) {
    return array.map((item) => {
      return {
        id: item.id,
        value: item.name,
      };
    });
  }

  async loadTeams() {
    const teams = this.convertToValueLabel(
      (await this.store.query('team', {})).sort((a, b) =>
        nameSort(a.name, b.name),
      ),
    );
    return teams;
  }

  restoreTeam(team_id) {
    const team = this.store.peekRecord('team', team_id);
    team.active = true;
    team.save().then(() => {
      this.notifications.notificationMessage = this.intl.t(
        '_teams.restored-success',
      );
      this.notifications.toggleShowNotification();
    });
  }
}
